import styled from 'styled-components';

export const PageWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 0;
`;
export const PageContent = styled.div`
  max-width: 686px;
`;
